import type { ReactNode } from "react";
import { Checkbox } from "../Checkbox";
import { RadioIndicator } from "../RadioIndicator";
import { Switch } from "../Switch";
export const renderIndicator = ({
  mode,
  selected,
  disabled
}: {
  mode: "radio" | "checkbox" | "switch";
  selected: boolean;
  disabled: boolean;
}): ReactNode => {
  switch (mode) {
    case "checkbox":
      return <Checkbox checked={selected} disabled={disabled} native={false} focusable={false} tabIndex={-1} aria-hidden={true} />;
    case "radio":
      return <RadioIndicator checked={selected} disabled={disabled} focusable={false} tabIndex={-1} aria-hidden={true} />;
    case "switch":
      return <Switch checked={selected} disabled={disabled} native={false} focusable={false} tabIndex={-1} aria-hidden={true}>
          <Switch.Thumb>
            <Switch.ThumbIcon />
          </Switch.Thumb>
        </Switch>;
  }
};